
import { format } from "date-fns";
import { useCallback, useContext } from "react";
import { GoogleLoginContext } from "../../contexts/GoogleLoginContext";

export function useQueryReport() {
  // const { token } = useAuthContext();
  const { profile, ProfileAdded, clientId, setToken, token } = useContext(GoogleLoginContext);

  const requestDimensions = (dimensions) => {
    let result = [];
    dimensions.forEach((item) => {
      result.push({
        name: item,
      });
    });
    return result;
  };

  const fetchData = useCallback(


    async (props) => {
      const {
        client_id,
        property_id,
        startDate,
        endDate,
        metrics,
        dimensions,
        orderBy,
        filter,
      } = props;

      const propertyId = parseInt(property_id)
      console.log(`https://analyticsdata.googleapis.com/v1beta/properties/318480319:batchRunReports`);
      const resp = await fetch(
        // "https://analyticsreporting.googleapis.com/v4/reports:batchGet",
        'https://analyticsdata.googleapis.com/v1beta/properties/318480319:batchRunReports',
        // 'https://analyticsdata.googleapis.com/v1beta/properties/318480319:runReport',
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            property: property_id,
            requests: [
              {

                filtersExpression: filter,
                dateRanges: [
                  {
                    startDate: format(new Date(startDate), "yyyy-MM-dd"),
                    endDate: format(new Date(endDate), "yyyy-MM-dd"),
                  },
                ],
                metrics: [
                  {
                    name: metrics,
                  },
                ],
                dimensions: requestDimensions(dimensions),
                // orderBys: orderBy
                //   ? [
                //     {
                //       fieldName: orderBy.fieldName,
                //       sortOrder: orderBy.order,
                //     },
                //   ]
                //   : [],
              },
            ],
          }),
        }
      );
      const data = await resp.json();
      console.log(data);

      if (data.error) {
        return data.error;
      }

      return data;
    },



    [token]
  );

  return { fetchData };
}
